<template>
  <div class="jurisdiction">
    <!-- 权限分配 -->
    <div class="organization-left">
      <div class="left-button">组织架构</div>
      <div class="trees-cont-scroll">
        <Tree
          class="trees"
          :data="data"
          @on-select-change="handleChange"
        ></Tree>
      </div>

      <!-- multiple -->
    </div>
    <div class="organization-right" v-show="lizhiPeopleShow">
      <div class="title-title">
        <span class="title">
          <Input
            placeholder="搜索"
            v-model="userName"
            style="width: auto"
            @on-enter="getUserListByStructureIds()"
            @on-clear="getUserListByStructureIds"
            clearable
          >
            <Icon
              type="ios-search"
              slot="prefix"
              @click="getUserListByStructureIds()"
            />
          </Input>
        </span>
        <Button
          class="title-btn fiveSize"
          type="success"
          ghost
          @click="changesliceIshhow(1)"
          >批量删除角色</Button
        >
        <Button
          class="title-btn fiveSize"
          type="success"
          ghost
          @click="changesliceIshhow(2)"
          >批量新增角色</Button
        >
      </div>
      <div class="title-cont">
        <span v-for="(item, index) in titleList" :key="index">
          <span :class="{ 'title-bu': index == titleList.length - 1 }">{{
            item.structureName
          }}</span>
          <Icon
            class="title-icon"
            type="ios-arrow-forward"
            v-show="index !== titleList.length - 1"
          />
        </span>
        <!-- <span v-show="lizhiTitleIsshow" class="lizhiTitle">已离职员工角色只做为记录，并不具有可操作权限</span> -->
      </div>
      <div class="organizationContentOne-tablie" style="margin-top:35px;">
        <Table
          @on-sort-change="changesort"
          stripe
          @on-selection-change="selectList"
          :columns="columns"
          :data="datalist"
        ></Table>
      </div>

      <div class="page-div">
        <div class="page-div-left  page-div-lefts">
          已选 <span>{{ selectNum }}</span> 条
        </div>
        <Button
          class="title-btn fourSize"
          type="success"
          ghost
          @click="sliceTable"
          >清空角色</Button
        >
        <Page
          @on-page-size-change="changepage"
          :total="tableObj.total"
          show-elevator
          show-total
          @on-change="changecurrent"
          :current="pageNum"
          :page-size="pageSize"
          show-sizer
          class="page-div-page"
        />
        <!-- <Page :total="1000" show-elevator show-total :current="current" :page-size="20" show-sizer class="page-div-page"/> -->
      </div>
    </div>

    <div class="organization-right" v-show="!lizhiPeopleShow">
      <div class="title-title">
        <span class="title">离职员工</span>
        <span style="margin-left:55px;"
          >已离职员工角色只做为记录，并不具有可操作权限</span
        >
        <Button class="title-btn" type="success" ghost @click="peoplePiLiang"
          >批量导出</Button
        >
      </div>
      <div class="organizationContentOne-tablie">
        <Table
          stripe
          @on-selection-change="selectChangepeople"
          :columns="columnspeople"
          :data="people"
          @on-sort-change="changesortPeople"
        ></Table>
      </div>
      <div class="page-div">
        <div class="page-div-left">
          已选 <span>{{ peopleselectNum }}</span> 条
        </div>
        <Page
          @on-page-size-change="changepeoplepage"
          :total="peopletotal"
          show-elevator
          show-total
          @on-change="changePeoplecurrent"
          :current="peoplepageNum"
          :page-size="peoplepageSize"
          show-sizer
          class="page-div-page"
        />
      </div>
    </div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >
    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->

    <!-- 修改弹框 -->
    <Modal
      v-model="bumenModal1"
      footer-hide
      title="选择角色"
      width="700px"
      class="secondBumen"
    >
      <Transfernew
        ref="Transfernew"
        @postRightList="postRightList"
      ></Transfernew>
    </Modal>

    <!-- 点击批量添加或删除选中列表信息后 -->
    <Modal class="ivumodal" v-model="sliceIshhow" :title="titleno" footer-hide>
      <div class="ivumodal-cont ivumodal-conts">
        每人角色是多可设置5个
        <Select
          v-model="selectData"
          @on-change="selectChange"
          :label-in-value="true"
        >
          <Option
            v-for="item in optionList"
            :value="item.roleId"
            :key="item.roleId"
            >{{ item.roleName }}</Option
          >
        </Select>
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="cancel(1)"
          >取消</Button
        >
        <Button class="btn sure" type="success" ghost @click="ok(1)"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- 点击批量添加或删除 "没有" 选中列表信息 -->
    <Modal class="ivumodal" v-model="titleIshhow" :title="titleno" footer-hide>
      <div class="ivumodal-cont">
        {{ titleitem }}
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="cancel(2)"
          >取消</Button
        >
        <Button class="btn sure" type="success" ghost @click="ok(2)"
          >确定</Button
        >
      </div>
    </Modal>
    <Modal class="ivumodal" v-model="clearbos" title="清空确认" footer-hide>
      <div class="ivumodal-cont">
        是否确认将角色清空？
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="cancel(3)"
          >取消</Button
        >
        <Button class="btn sure" type="success" ghost @click="clearUserRole()"
          >确定</Button
        >
      </div>
    </Modal>
    <Modal
      class="ivumodal"
      v-model="peopletitleIshhow"
      title="删除确认"
      footer-hide
    >
      <div class="ivumodal-cont">
        请选择需要操作的数据
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="peopletitleIshhowok(2)"
          >取消</Button
        >
        <Button
          class="btn sure"
          type="success"
          ghost
          @click="peopletitleIshhowok(2)"
          >确定</Button
        >
      </div>
    </Modal>
    <Modal
      class="ivumodal"
      v-model="peopletitleIshhow2"
      title="清空确认"
      footer-hide
    >
      <div class="ivumodal-cont">
        请选择需要操作的数据
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="peopletitleIshhowok(2)"
          >取消</Button
        >
        <Button
          class="btn sure"
          type="success"
          ghost
          @click="peopletitleIshhowok(2)"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
    import {
        deleteSeparatedEmployee,
        getSeparatedEmployeeList,
        getStructureTree,
        getUserListByStructureId,
        getSubordinateList,
        addRoleToUserList,
        selectRole,
        deleteRoleForUserList,
        clearUserRole,
        updateUserRole
    } from "../servers/api";
    import Transfernew from "../tan/transfernew";
    import Vue from "vue";
    export default {
        name: "jurisdiction",
        data() {
            return {
                alertTitle: "",
                userName: "",
                alertTitleIshow2: false,
                alertTitleIshow: false,
                lizhiPeopleShow: true,
                isiconfontshow: true,
                ispiliang: false,
                titleIshhow: false,
                titleitem: "",
                peopletitleIshhow2: false,
                clearbos: false,
                titleno: "批量新增角色",
                title: "每人角色是多可设置5个",
                bumenModal1: false, //修改弹框
                sliceIshhow: false, //删除确认
                data: [], //树形数据
                treeitem: {}, //存储点击的树形数据
                treeData: [],
                pageNum: 1,
                datalist: [],
                columns: [{
                    type: "selection",
                    width: 70,
                    align: "center"
                }, {
                    title: "姓名",
                    width: 90,
                    align: "center",
                    key: "userName",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "部门",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "structureName",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    },
                                    domProps: {
                                        title: params.row.structureName
                                    }
                                },
                                params.row.structureName
                            )
                        ]);
                    }
                }, {
                    title: "职位",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "position"
                }, {
                    title: "当前角色",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "roles",
                    render: (h, params) => {
                        let str = [];
                        if (params.row.roles.length > 0) {
                            for (let i = 0; i < params.row.roles.length; i++) {
                                str.push(params.row.roles[i].roleName);
                            }
                        }
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    },
                                    domProps: {
                                        title: str.join()
                                    }
                                },
                                str.join()
                            )
                        ]);
                    }
                }, {
                    title: "修改",
                    key: "awssd",
                    align: "center",
                    width: 100,
                    render: (h, params) => {
                        return h(
                            "div", {
                                style: {
                                    height: "30px",
                                    width: "50px",
                                    "line-height": "30px",
                                    "text-align": "center",
                                    "font-size": "13px",
                                    background: "#fff",
                                    border: "1px solid #53CAC3",
                                    "border-radius": "5px",
                                    "margin-left": "8px",
                                    cursor: "pointer"
                                },
                                on: {
                                    click: () => {
                                        this.chengeTable(params.row);
                                    }
                                }
                            },
                            "修改"
                        );
                    }
                }], //表格数据
                optionList: [],
                selectNum: 0, //已选多少条
                selectData: "", //存储角色选择信息
                tableObj: {}, //存储
                pageSize: 20, //请求条数
                titleList: [], //存储顶部title的
                treeItemcun: {}, //储存树形的第一项默认
                selectLists: [], //存储多选的表格信息
                selectJueseList: [], //选择角色多选存储id‘
                clearUserId: "", //清空id
                userId: "",
                roleIdList: [],
                paixuKey: "",
                paixuSc: "",
                selectlabel: "",
                loginName: "",
                loginNameList: [],
                lizhiTitleIsshow: false, //已离职员工角色只做为记录，并不具有可操作权限 =>显示
                people: [],
                peopleselectNum: 0, //离职有人缘已选
                peopleSelectList: [], //离职员工多选存储
                peopletotal: 0, //总条数
                peoplepageSize: 20,
                peoplepageNum: 1,
                columnspeople: [{
                    type: "selection",
                    width: 70,
                    align: "center"
                }, {
                    title: "姓名",
                    // width: 90,
                    align: "center",
                    ellipsis: true,
                    key: "userName",
                    sortable: true
                }, {
                    title: "部门",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "structureName"
                }, {
                    title: "职位",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "position"
                }, {
                    title: "离职前角色",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "roleList",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    },
                                    domProps: {
                                        title: params.row.roleList
                                    }
                                },
                                params.row.roleList
                            )
                        ]);
                    }
                }],
                isAsc: "",
                orderField: "",
                peopleLizhi: false,
                titlename: "",
                title: "",
                peopletitleIshhow: false
            };
        },
        created() {
            this.getTree();
            this.getUserListByStructureIds();
            this.getSubordinateList();
        },
        components: {
            Transfernew
        },
        methods: {
            peopletitleIshhowok() {
                this.peopletitleIshhow = false;
                this.peopletitleIshhow2 = false;
            },
            changePeoplecurrent(page) {
                //离职人员换页
                this.peoplepageNum = page;
                this.peopleSelectList = [];
                this.peopleselectNum = this.peopleSelectList.length;
                this.lizhiPeople();
            },
            changepeoplepage(num) {
                //离职人员切换请求条数
                this.peoplepageSize = num;
                this.peoplepageNum = 1;
                this.lizhiPeople();
            },
            lizhiPeople(num) {
                //离职成员展示的页面并请求离职员工接口
                this.pageNum = 1;
                this.lizhiPeopleShow = false;
                if (num) {
                    this.peoplepageNum = 1;
                }
                let params = {
                    pageNum: this.peoplepageNum,
                    pageSize: this.peoplepageSize,
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                this.isiconfontshow = true;
                getSeparatedEmployeeList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.people = res.data.data.list;
                        this.peoplepageNum = res.data.data.pageNum;
                        if (res.data.data.pageNum == 0) {
                            this.peoplepageNum = 1;
                        }
                        this.peopletotal = res.data.data.total;
                    }
                });
            },
            selectChangepeople(item) {
                //离职员工多选
                this.peopleSelectList = item;
                this.peopleselectNum = this.peopleSelectList.length;
            },
            changesortPeople(item) {
                //排序
                this.isAsc = item.order;
                this.orderField = item.key;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.peopleSelectList = [];
                this.peopleselectNum = this.peopleSelectList.length;
                this.lizhiPeople(1);
            },
            peoplePiLiang() {
                //离职人员批量导出
                // let baseUrl = ''
                // if (process.env.NODE_ENV === 'development') {
                //   baseUrl = 'http://192.168.1.114:9000';
                // } else {
                //   if (process.env.NODE_ENV === 'production') {
                //     let _host = window.location.host;
                //     if (_host == '192.168.1.23') { //测试
                //       baseUrl = "http://192.168.1.22:9000"
                //     } else if (_host == '114.215.67.3') {
                //       baseUrl = "http://114.215.67.3:9000"
                //     }
                //   }
                // }
                // let list = [];
                // let token = JSON.parse(sessionStorage.getItem('login')).token || '';
                // if (this.peopleSelectList.length > 0) {
                //   for (let i = 0; i < this.peopleSelectList.length; i++) {
                //     list.push(this.peopleSelectList[i].id)
                //   }
                // }
                // window.location.href = baseUrl + '/wts/admin/struc/exportSeparatedEmployeeList?idList=' + list.join(',') + "&token=" + token;
            },
            lizhiPeople(num) {
                //离职成员展示的页面并请求离职员工接口
                this.current = 1;
                this.lizhiPeopleShow = false;
                if (num) {
                    this.peoplepageNum = 1;
                }
                let params = {
                    pageNum: this.peoplepageNum,
                    pageSize: this.peoplepageSize,
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                this.isiconfontshow = true;
                getSeparatedEmployeeList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.people = res.data.data.list;
                        this.peoplepageNum = res.data.data.pageNum;
                        if (res.data.data.pageNum == 0) {
                            this.peoplepageNum = 1;
                        }
                        this.peopletotal = res.data.data.total;
                    }
                });
            },
            selectChange(item) {
                this.selectlabel = item.label;
            },
            changepage(num) {
                //换请求条数
                this.pageSize = num;
                this.pageNum = 1;
                this.getUserListByStructureIds(this.treeitem.id);
            },
            postRightList(item, loginName) {
                //组组件传来的参数
                if (item == false) {
                    //关闭弹框 return阻拦向下执行
                    this.bumenModal1 = false;
                    return;
                }
                this.roleIdList = item;
                this.loginNameList = loginName;
                this.updateUserRole();
            },
            updateUserRole() {
                //修改
                let cont = "";
                let contlogin = "";
                if (typeof this.roleIdList == "string") {
                    //如果为空直接传空 不为空传数组id
                    cont = "";
                    contlogin = "";
                } else {
                    cont = this.roleIdList.join(",");
                    contlogin = this.loginNameList.join(",");
                }
                let params = {
                    userId: this.userId,
                    roleIdList: cont,
                    loginName: this.loginName,
                    roleNameList: contlogin
                };
                this.isiconfontshow = true;
                updateUserRole(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.bumenModal1 = false;
                        this.getUserListByStructureIds(this.treeitem.id);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            chengeTable(params) {
                //表格点击修改
                this.userId = params.userId;
                this.bumenModal1 = true;
                this.loginName = params.loginName;
                this.$refs.Transfernew.getRoleListByUserId(params, this.userId);
            },
            sliceTable(params) {
                //清空点击
                if (this.selectNum == 0) {
                    this.peopletitleIshhow2 = true;
                } else {
                    let list = [];
                    let nameList = [];
                    for (let i = 0; i < this.selectLists.length; i++) {
                        list.push(this.selectLists[i].userId);
                        nameList.push(this.selectLists[i].loginName);
                    }
                    this.clearUserId = list.join(",");
                    this.loginName = nameList.join(",");
                    this.clearbos = true;
                }
            },
            clearUserRole(item) {
                //清空接口
                let params = {
                    userId: this.clearUserId,
                    loginName: this.loginName
                };
                this.isiconfontshow = true;
                clearUserRole(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.clearbos = false;
                        this.getUserListByStructureIds(this.treeitem.id);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            changesliceIshhow(index) {
                //批量
                this.selectData = "";
                if (index == 2) {
                    this.titleno = "批新增角色";
                    if (this.selectLists.length > 0) {
                        this.selectRole();
                        this.sliceIshhow = true;
                    } else {
                        this.titleIshhow = true;
                        this.titleitem = "请选择需要操作的数据";
                    }
                } else {
                    this.titleno = "批量删除角色";
                    if (this.selectLists.length > 0) {
                        this.selectRole();
                        this.sliceIshhow = true;
                    } else {
                        this.titleIshhow = true;
                        this.titleitem = "请选择需要操作的数据";
                    }
                }
            },
            deleteRoleForUserList(list, item, loginName) {
                //批量删除角色
                let params = {
                    userIdList: list,
                    roleId: item,
                    loginNameList: loginName,
                    roleName: this.selectlabel
                };
                this.isiconfontshow = true;
                deleteRoleForUserList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.sliceIshhow = false;
                        this.getUserListByStructureIds(this.treeitem.id);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            cancel(index) {
                //弹框取消
                if (index == 1) {
                    this.sliceIshhow = false;
                } else if (index == 2) {
                    this.titleIshhow = false;
                } else {
                    this.clearbos = false;
                }
            },
            ok(index) {
                //弹框确定
                if (index == 1) {
                    if (this.selectData !== "") {
                        let list = [];
                        let loginNameLsit = [];
                        for (let i = 0; i < this.selectLists.length; i++) {
                            list.push(this.selectLists[i].userId);
                            loginNameLsit.push(this.selectLists[i].loginName);
                        }
                        if (this.titleno == "批量删除角色") {
                            this.deleteRoleForUserList(
                                list.join(","),
                                this.selectData,
                                loginNameLsit.join(",")
                            );
                        } else {
                            this.addRoleToUserList(
                                list.join(","),
                                this.selectData,
                                loginNameLsit.join(",")
                            ); // list.join(',')//表格选中用户id数组 this.selectData角色id数组
                        }
                    } else {
                        this.sliceIshhow = false;
                    }
                } else {
                    this.titleIshhow = false;
                }
            },
            addRoleToUserList(list, item, loginName) {
                //批量添加角色
                let params = {
                    userIdList: list,
                    roleId: item,
                    loginNameList: loginName,
                    roleName: this.selectlabel
                };
                this.isiconfontshow = true;
                addRoleToUserList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.sliceIshhow = false;
                        this.getUserListByStructureIds(this.treeitem.id);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            selectList(list) {
                //多选
                this.selectLists = list;
                this.selectNum = this.selectLists.length;
            },
            getSubordinateList(id) {
                //获取点击的tab展示；
                let params = {
                    structureId: id || 1
                };
                this.isiconfontshow = true;
                getSubordinateList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.titleList = res.data.data.parentList;
                        this.titleList.reverse();
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            changecurrent(page) {
                //切换页码
                this.pageNum = page;
                this.selectLists = [];
                this.selectNum = 0;
                this.getUserListByStructureIds(this.treeitem.id);
            },
            getUserListByStructureIds(id) {
                //获取表格、searchStructionByName
                this.selectLists = [];
                this.selectNum = this.selectLists.length;
                let params = {
                    structureId: id || 1,
                    isAll: 1, //是否显示所有下级部门人员列表,1-是,0-否
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    orderField: this.paixuKey,
                    isAsc: this.paixuSc,
                    userName: encodeURIComponent(this.userName, "utf-8")
                };
                this.isiconfontshow = true;
                if (id == -1) {
                    //离职员工提示展示
                    this.lizhiTitleIsshow = true;
                } else {
                    this.lizhiTitleIsshow = false;
                }
                getUserListByStructureId(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.datalist = res.data.data.list || [];
                        this.tableObj = res.data.data || {};
                        this.pageNum = this.tableObj.pageNum;
                        this.selectLists = [];
                        this.selectNum = 0;
                        if (this.tableObj.pageNum == 0) {
                            this.pageNum = 1;
                        }
                    } else {
                        this.datalist = [];
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            getTree() {
                //获取树形
                let params = {
                    parentId: "1"
                };
                // this.isiconfontshow = true;
                getStructureTree(params).then(res => {
                    if (res.data.code == 1) {
                        this.data = res.data.data || [];
                        this.treeItemcun = res.data.data[0];
                        this.data.selected = true;
                        this.data.expand = false;
                        this.handleChange(this.data);
                    } else {
                        this.ishowtitle = true;
                    }
                });
            },
            changesort(column) {
                //排序
                this.selectLists = [];
                this.selectNum = this.selectLists.length;
                this.paixuKey = column.key;
                this.paixuSc = column.order;
                if (column.order == "normal") {
                    this.paixuSc = "";
                    this.paixuKey = "";
                }
                this.getUserListByStructureIds(this.treeitem.id);
            },
            selectRole() {
                //获取角色接口
                selectRole().then(res => {
                    if (res.data.code == 1) {
                        this.optionList = res.data.data;
                    }
                });
            },
            handleChange(e) {
                if (e.length > 0) {
                    Vue.set(e[0], "selected", true);
                    if (e[0].expand) {
                        Vue.set(e[0], "expand", false);
                    }
                    e[0].selected = true;
                    e[0].expand = !e[0].expand;
                    this.treeData = e;
                } else {
                    e = this.treeData;
                    if (e[0].expand) {
                        Vue.set(e[0], "expand", false);
                    }
                    Vue.set(e[0], "selected", true);
                    e[0].selected = true;
                    e[0].expand = !e[0].expand;
                }
                if (e[0].id !== -1) {
                    this.getUserListByStructureIds(e[0].id);
                    this.getSubordinateList(e[0].id);
                    this.lizhiPeopleShow = true;
                } else {
                    this.lizhiPeople(1);
                    this.lizhiPeopleShow = false;
                }
            }
        },
        mounted() {}
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .trees-cont-scroll {
        height: calc(100% - 30px);
        padding-bottom: 20px;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
    }
    
    .organizationContentOne-tablie {
        margin: 40px 0 60px;
    }
    
    .lizhiTitle {
        margin-left: 50px;
    }
    
    .jurisdiction-select {
        width: 270px;
    }
    
    .ivu-select /deep/ .ivu-select-item {
        line-height: 30px;
    }
    
    .ivu-select {
        display: block;
        width: 400px;
        margin: 0 auto;
    }
    
    .ivumodal-conts {
        line-height: 50px;
    }
    
    .aaa {
        // border: 1px solid red;
        margin-top: 100px;
        height: 100px;
        width: 100px;
        // border-radius: 5px;
    }
    
    .jurisdiction {
        width: 100%;
        height: 100%;
        font-family: SimHei;
        font-size: 13px;
        color: #7f7f7f;
        .ivu-input-wrapper /deep/ .ivu-input {
            border-color: #53cac3;
            width: 250px;
        }
        .title-cont {
            margin-bottom: 15px;
            .ti70le-icon {
                margin-left: 5px;
            }
            .title-bu {
                color: #53cac3;
            }
        }
        .title-title {
            width: calc(100% - 475px);
            height: 60px;
            line-height: 35px;
            position: fixed;
            top: 111px;
            z-index: 99;
            background: #fff;
            padding-top: 17px;
            left: 461px;
            padding-left: 15px;
            padding-bottom: 15px;
            .title {
                font-size: 16px;
                font-weight: 600;
                margin-right: 15px;
                line-height: 20px;
                display: inline-block;
                height: 100%;
            }
            .ivu-btn-success {
                border-color: #53cac3;
                color: #7f7f7f;
                height: 30px;
                margin-top: -5px;
            }
            .title-btn {
                float: right;
                margin-right: 15px;
                margin-top: 4px;
            }
        }
        .organization-left {
            padding: 15px;
            padding-right: 0;
            width: 240px;
            border-right: 1px solid #d7d7d7;
            height: calc(100% - 100px);
            position: absolute;
            .left-button {
                width: 210px;
                border: 1px solid #53cac3;
                height: 30px;
                text-align: center;
                line-height: 30px;
                border-top-left-radius: 11px;
                border-top-right-radius: 11px;
            }
        }
        .organization-right {
            padding: 15px;
            padding-bottom: 30px;
            height: 100%;
            margin-left: 240px;
            font-family: SimHei;
            color: #7f7f7f;
            overflow: hidden;
            overflow-y: scroll;
            overflow-y: visible;
        }
        .page-div {
            width: 100%;
            margin-top: 15px;
            position: fixed;
            background: #fff;
            width: calc(100% - 490px);
            height: 60px;
            z-index: 99;
            bottom: 0;
            padding-top: 15px;
            .page-div-left {
                float: left;
                padding: 5px 10px;
            }
            .page-div-lefts {
                border-right: 1px solid #d7d7d7;
                margin-right: 15px;
            }
            .page-div-page {
                float: right;
                margin-right: 15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shezhi/jurisdiction.vue